import {ValidationErrors} from 'platform/components';

import {ApiError} from 'shared/web';

import {handleApiError} from './handleApiError';
import {mapCustomerValidationErrors} from './mapCustomerValidationErrors';

/** Shows the 400 `validationErrors` of a contact write on the contact form fields. */
export const handleContactApiError = (
  error: ApiError,
  setErrors: (errors: ValidationErrors | null) => void,
  emailFormIndexes: number[]
) =>
  handleApiError(error, {
    silentOnValidationError: true,
    setErrors: (errors) =>
      setErrors(mapCustomerValidationErrors(errors, {emailsPath: 'emails', emailFormIndexes})),
  });
